import * as React from "react";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";

const styles = (theme, props) => ({
  disabled: {
    opacity: 0.55,
    pointerEvents: "none",
  },
  tooltip: {
    display: "flex",
    alignItems: "center",
  },
  item: {
    width: "33px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    color: "#999",
    height: "100%",
    transition: "all 0.3s ease-in",
    ...props.styles,
  },
  icon: {
    color: `${props.fontColor || "#fff"}`,
    fontSize: `${props.fontSize || 22}px`,
    transform: `rotate(${props.rotate || 0}deg)`,
    /*'&:hover': {
			color: '#ABC200'
		},*/
    "&:active": {
      color: "#ABC200",
    },
    transition: "all 0.3s ease-in",
  },
});

const withStylesProps = (styles) => (Component) => (props) => {
  const Comp = withStyles((theme) => styles(theme, props))(Component);
  return <Comp {...props} />;
};

const ToolBarItem = ({
  classes,
  Icon,
  action,
  iconClass,
  title,
  placement,
  disabled,
}) => {
  let inside = (
    <div
      className={classNames(classes.item, { [classes.disabled]: !!disabled })}
      onClick={action}
    >
      <Icon
        className={classNames(classes.icon, { [iconClass]: !!iconClass })}
      />
    </div>
  );
  return title ? (
    <Tooltip
      title={title}
      placement={placement ? placement : "bottom"}
      style={{ height: "100%" }}
    >
      {inside}
    </Tooltip>
  ) : (
    inside
  );
};

export default withStylesProps(styles)(ToolBarItem);



// WEBPACK FOOTER //
// ./src/modules/project/components/layouts/ToolBarItem.tsx